import "./RoboticsCourseHP6.module.css";
import Header from "@/reusable_sections/Header";
import RoboticsCourseHP6Detail from "./sections/RoboticsCourseHP6Detail";
import Footer from "@/reusable_sections/Footer";
export default function RoboticsCourseHP6Page() {
  return <div>
      <Header />
      <RoboticsCourseHP6Detail />
      <Footer />
    </div>;
}